class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      // document.body.style.pointerEvents = 'none';
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

function getCartQuantityErrorMessage(quantity) {
  if (!window.cartStrings?.quantityError) return '';
  return window.cartStrings.quantityError.replace('[quantity]', quantity);
}

window.applyCartLineQuantityError = function () {
  if (!window._cartLineQuantityError) return;
  const { line, message } = window._cartLineQuantityError;
  const lineItemError =
    document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
  if (!lineItemError) return;
  const errorText = lineItemError.querySelector('.cart-item__error-text');
  if (errorText) errorText.innerHTML = message;
};

window.setCartLineQuantityError = function (line, message) {
  if (message && message.trim() !== '') {
    window._cartLineQuantityError = { line, message };
  } else {
    window._cartLineQuantityError = null;
  }
  window.applyCartLineQuantityError();
};

window.showCartLineQuantityError = function (line, maxQuantity) {
  window.setCartLineQuantityError(line, getCartQuantityErrorMessage(maxQuantity));
};

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    // const checkoutButton = document.getElementById('CartDrawer-Checkout');
    // if (checkoutButton) {
    //   checkoutButton.disabled = true;
    // }
    // document.body.style.pointerEvents = 'none';
    // window.updateFreeGift();


    // window.CheckAndRemoveFreebies();
    // if (typeof window.CheckAndRemoveFreebies === "function") {
    //   window.CheckAndRemoveFreebies();
    // }
    //  document.body.style.pointerEvents = "none";
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const requestedQuantity = parseInt(quantity, 10);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

        if (parsedState.errors || parsedState.status === 422) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value') ?? quantityElement.value;
          }
          const quantityError = parsedState.errors?.quantity;
          const errorMessage =
            (typeof parsedState.errors === 'string' && parsedState.errors) ||
            (Array.isArray(quantityError) ? quantityError[0] : quantityError) ||
            parsedState.message ||
            parsedState.description ||
            window.cartStrings.error;
          this.updateLiveRegions(line, errorMessage);
          document.body.style.pointerEvents = 'unset';
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          try {
            const container = document.getElementById(section.id);
            if (!container || !parsedState.sections?.[section.section]) return;

            const elementToReplace = container.querySelector(section.selector) || container;
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          } catch (sectionError) {
            console.error('Cart section render error:', section.id, sectionError);
          }
        });
        // custom code for empty cart recommendations slider
        if (parsedState.item_count === 0 && typeof window.initEmptyCartSliderMouseScroll === 'function') {
          setTimeout(function () { window.initEmptyCartSliderMouseScroll(); }, 150);
          setTimeout(function () { if (typeof ReloadSmartWishlist === 'function') ReloadSmartWishlist(); }, 150);
        }
        // custom code for empty cart recommendations slider end
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

        // window.updateFreeGift();


         if (variantId) {
            window.handleCartQuantity({
            variantId: variantId,
            quantity: updatedValue || quantity, 
            name: name, 
            cartId: parsedState.token
          });
        }

        let message = '';
        let hasError = false;
        if (!Number.isNaN(requestedQuantity) && updatedValue !== requestedQuantity) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
            hasError = true;
          } else {
            message = getCartQuantityErrorMessage(updatedValue);
            hasError = true;
          }
        } else if (!Number.isNaN(requestedQuantity)) {
          window.setCartLineQuantityError(line, '');
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

      // if (checkoutButton){
      //   checkoutButton.disabled = true;
      //   document.body.style.pointerEvents = "none";
      // } 
      // document.body.style.pointerEvents = "none";
      //   // window.NewFreebieAdded();
      //   if (typeof window.NewFreebieAdded === "function") {
      //     window.NewFreebieAdded();
      //   }
      //   // window.CheckAndRemoveFreebies();
      //   if (typeof window.CheckAndRemoveFreebies === "function") {
      //     window.CheckAndRemoveFreebies();
      //   }

      if (hasError) {
        document.body.style.pointerEvents = 'unset';
        setTimeout(() => {
          if (typeof window.applyCartLineQuantityError === 'function') {
            window.applyCartLineQuantityError();
          }
        }, 400);
      }

      if (window.FREE_GIFT_SETTINGS && typeof window.isFreeGiftConfigured === 'function' && window.isFreeGiftConfigured()) {
        const totalCents = typeof window.getEligibleCartTotalCents === 'function'
          ? window.getEligibleCartTotalCents(parsedState)
          : parsedState.total_price;
        const totalAmount = totalCents / 100; 
        const minAmount = window.FREE_GIFT_SETTINGS.minValue / 100;
        const maxAmount = window.FREE_GIFT_SETTINGS.maxValue / 100;
        
        const diffEl = document.querySelector(".cart-diwali-diff");
        const msgEl = document.querySelector(".cart-diwali-upper-msg");

        if (diffEl && msgEl) {
          if (totalAmount >= maxAmount) {

            msgEl.innerHTML = `🎉 Congratulations! You got Free Lamp`;
            
            msgEl.setAttribute('data-congratulations-locked', 'true');
            

            if (typeof startCongratulationsObserver === 'function') {
              startCongratulationsObserver();
            }
            
            Object.defineProperty(msgEl, 'innerHTML', {
              set: function(value) {
                if (this.getAttribute('data-congratulations-locked') === 'true' && !value.includes('Congratulations')) {
                  return;
                }
                Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML').set.call(this, value);
              },
              get: function() {
                return Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML').get.call(this);
              },
              configurable: true
            });

            const restoreCongratulations = () => {
              const msgElAfter = document.querySelector(".cart-diwali-upper-msg");
              if (msgElAfter && msgElAfter.getAttribute('data-congratulations-locked') === 'true') {
                if (!msgElAfter.innerHTML.includes('Congratulations')) {
                  msgElAfter.innerHTML = `🎉 Congratulations! You got Free Lamp`;
                }
              }
            };
            
            setTimeout(restoreCongratulations, 50);
            setTimeout(restoreCongratulations, 100);
            setTimeout(restoreCongratulations, 200);
            setTimeout(restoreCongratulations, 500);

            window.skipMessageUpdate = true;
          } else {

            msgEl.removeAttribute('data-congratulations-locked');
            if (typeof stopCongratulationsObserver === 'function') {
              stopCongratulationsObserver();
            }
            window.skipMessageUpdate = false;
            
            try {
              delete msgEl.innerHTML;
            } catch (e) {
              // Property might not be deletable, that's okay
            }
            
            if (totalAmount < minAmount) {
              const diff = (minAmount - totalAmount).toFixed(2);
              diffEl.textContent = 'TZS ' + diff;
              msgEl.innerHTML = `Purchase worth <span class="cart-diwali-diff"><strong>AED ${diff}</strong></span> more to get <strong>Free Lamp</strong>`;
              msgEl.style.display = "block";
            } else {
              const nextThreshold = (Math.floor(totalAmount / minAmount) + 1) * minAmount;
              const diff = (nextThreshold - totalAmount).toFixed(2);
              diffEl.textContent = 'TZS ' + diff;
              msgEl.innerHTML = `Purchase worth <span class="cart-diwali-diff"><strong>AED ${diff}</strong></span> more to get another <strong>Free Lamp</strong>`;
              msgEl.style.display = "block";
            }
          }
        }
      }

      if (typeof window.isFreeGiftConfigured === 'function' && window.isFreeGiftConfigured() && typeof window.updateFreeGift === 'function') {
        window.updateFreeGift();
      }

      // return window.handleFreebieRemove(); // returns a Promise

      
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
        document.body.style.pointerEvents = 'unset';
      })
      .finally(() => {
        this.disableLoading(line);
        document.body.style.pointerEvents = 'unset';
      });
  }

  updateLiveRegions(line, message) {
    window.setCartLineQuantityError(line, message);

    const hasErrorMessage = message && message.trim() !== '';
    if (hasErrorMessage) {
      document.body.style.pointerEvents = 'unset';
    }
    
    const checkoutButton = document.getElementById("CartDrawer-Checkout");
    if (checkoutButton) checkoutButton.disabled = false;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
      // Only set pointer events to 'none' if there's no error message
      // if (!hasErrorMessage) {
      //   document.body.style.pointerEvents = 'none';
      // }
    }, 10);
  }

  getSectionInnerHTML(html, selector) {
    const sectionRoot = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return sectionRoot ? sectionRoot.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

async function fetchData(ele, graphql) {
  var myHeaders = new Headers()
  myHeaders.append(
    'x-shopify-storefront-access-token',
    'e9eccba2395ed68b4815b8d03181350c'
  )
  myHeaders.append('Content-Type', 'application/json')

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: graphql,
    redirect: 'follow',
  }

  try {
    const response = await fetch(
      `${window.location.origin}/api/2023-04/graphql.json`,
      requestOptions
    )

    const result = await response.json()

    await fetch(`${window.location.href}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const sourceQty = html.querySelector('.cart-items')
        const sourceQty1 = html.querySelector('.drawer__footer')
        const sourceQty2 = html.querySelector('.coupons .couponTitle')
       
        document.querySelector('.cart-items').innerHTML =
          sourceQty.innerHTML
        document.querySelector('.drawer__footer').innerHTML = sourceQty1.innerHTML

        document.querySelector('.coupons .couponTitle').innerHTML =
          sourceQty2.innerHTML
        let applicable =
          result.data.cartDiscountCodesUpdate.cart.discountCodes[0].applicable
         if (
          ele == document.querySelector('.cart__coupon-submit') &&
          applicable
        ) {
          // document.querySelector('.coupons').style.display = 'flex'
          document.querySelector('.invalidCoupon').style.display = 'none'
          document.querySelector('.coupon-five-percent-offf-cart-drawer').classList.add('active');
        } else if (
          ele == document.querySelector('.cart__coupon-submit') &&
          !applicable
        ) {
          document.querySelector('.coupons').style.display = 'none'
          document.querySelector('.invalidCoupon').style.display = 'block'
        } else {
          document.querySelector('.coupons').style.display = 'none'
          document.querySelector('.invalidCoupon').style.display = 'none'
        }
      })
  } catch (error) {
    console.error(error)
  }


}

async function couponCodeUpdate(ele) {
  let cartCookies = document.cookie.split(';')
  let cartIds = cartCookies.find((e) => e.includes('cart'))
  const cartfetch = await fetch('/cart.js')
  const cartjson = await cartfetch.json()
  cartId = cartIds.split('=')[1]
  cartId = cartId.split('%')[0]
  
  let couponValue = document.querySelector('#coupon_code').value

  var graphql = JSON.stringify({
    query:
      ele == document.querySelector('.cart__coupon-submit')
        ? `mutation MyMutation {
            cartDiscountCodesUpdate(
              cartId: "gid://shopify/Cart/${cartjson.token}"
              discountCodes: "${couponValue}"
            ) {
              userErrors {
                field
                message
              }
              cart {
                discountCodes {
                  applicable
                  code
                }
              }
            }
          }`
        : `mutation MyMutation {
            cartDiscountCodesUpdate(
              cartId: "gid://shopify/Cart/${cartId}"
              discountCodes: ""
            ) {
              userErrors {
                field
                message
              }
              cart {
                discountCodes {
                  applicable
                  code
                }
              }
            }
          }`,
    variables: {},
  })

  fetchData(ele, graphql)
}



function offerApplied(e){
  couponCodeUpdate(e);
  e.classList.add('cart__coupon-submit-done');
}

document.querySelector('.deleteCoupon')?.addEventListener('click', (e) => {
  couponCodeUpdate(e.target)
})



  function updateTimerdeal() {
   
    const saleStartdeal = new Date(sessionStorage.getItem("endTime"));
    const saleEnddeal = new Date(saleStartdeal.getTime() + (10 * 60 * 1000));
    const nowdeal = new Date();
    const timeDifferencedeal = saleEnddeal - nowdeal;
    const offerContainer = document.querySelector('.coupon-five-percent-offf-cart-drawer');
  

    if (timeDifferencedeal <= 0) {
      if(offerContainer){
        offerContainer.style.display = 'none';
      }
      clearInterval(updateTimerdeal);
    } else if (timeDifferencedeal > 0 && nowdeal >= saleStartdeal) {
      const hoursd = Math.floor(timeDifferencedeal / (1000 * 60 * 60));
      const minutesd = Math.floor((timeDifferencedeal % (1000 * 60 * 60)) / (1000 * 60));
      const secondsd = Math.floor((timeDifferencedeal % (1000 * 60)) / 1000);

      const formattedHoursd = String(hoursd).padStart(2, '0');
      const formattedMinutesd = String(minutesd).padStart(2, '0');
      const formattedSecondsd = String(secondsd).padStart(2, '0');
      if(offerContainer){
        offerContainer.style.display = 'block';
      }
      if(document.querySelector('.time-countdown')){
         document.querySelectorAll('.time-countdown').forEach((each)=>{
           each.textContent = `${formattedMinutesd}:${formattedSecondsd} minutes`
         }); 
      }
    } else {
      if(offerContainer){
        offerContainer.style.display = 'none';
      }
      clearInterval(updateTimerdeal);
    }
  }
  updateTimerdeal();
  setInterval(updateTimerdeal, 1000);

function callGetPercentOff(){
 
   if( sessionStorage.getItem("showOffer") != "false" ){
     var currentTime = new Date();
     let timerEndTime = new Date( currentTime.getTime() + (10*60*1000) );
     sessionStorage.setItem("endTime", currentTime);
     sessionStorage.setItem('timerEndTime',timerEndTime);
     updateTimerdeal();
     setInterval(updateTimerdeal, 1000);
   }
   sessionStorage.setItem("showOffer", "false");
}

function syncCouponBannerFromDOM() {
  if (!window.COUPON_SETTINGS?.enabled) return;
  
  const couponContainer = document.querySelector('.coupon-five-percent-offf-cart-drawer');
  if (!couponContainer) return;
  const cartFooterDiscount = document.querySelector('.cart-drawer__footer .discounts__discount');
  const couponTitleEl = document.querySelector('.coupons .couponTitle');
  const hasCouponTitle = !!(couponTitleEl && couponTitleEl.textContent && couponTitleEl.textContent.trim().length);
  const hasDiscount = !!cartFooterDiscount || hasCouponTitle;
  couponContainer.classList.toggle('active', hasDiscount);
}


async function checkAndUpdateCouponState() {
  
  if (!window.COUPON_SETTINGS?.enabled) return;

  try { syncCouponBannerFromDOM(); } catch (e) {}
  
  try {
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    const hasDiscount = Array.isArray(cartData.discount_codes) && cartData.discount_codes.length > 0;
    const couponContainer = document.querySelector('.coupon-five-percent-offf-cart-drawer');
    const invalidCoupon = document.querySelector('.invalidCoupon');
    const coupons = document.querySelector('.coupons');
    if (couponContainer) {
      couponContainer.classList.toggle('active', hasDiscount);
    }
    if (invalidCoupon) {
      invalidCoupon.style.display = 'none';
    }
    if (coupons) {
      coupons.style.display = 'none';
    }

  } catch (error) {
    console.error('Error checking cart state:', error);
  }
}


document.addEventListener('visibilitychange', function() {
  if (!document.hidden && window.COUPON_SETTINGS?.enabled) {
    syncCouponBannerFromDOM();
    setTimeout(checkAndUpdateCouponState, 200);
  }
});

window.addEventListener('focus', function() {
  if (window.COUPON_SETTINGS?.enabled) {
    syncCouponBannerFromDOM();
    setTimeout(checkAndUpdateCouponState, 200);
  }
});

window.checkAndUpdateCouponState = checkAndUpdateCouponState;
window.syncCouponBannerFromDOM = syncCouponBannerFromDOM;

document.addEventListener('DOMContentLoaded', function() {
  if (window.COUPON_SETTINGS?.enabled) {
    syncCouponBannerFromDOM();
    setTimeout(checkAndUpdateCouponState, 200);
  }
});





// Function to get current timer value
function getCurrentTimerValue() {
  const saleStartdeal = new Date(sessionStorage.getItem("endTime"));
  const saleEnddeal = new Date(saleStartdeal.getTime() + (10 * 60 * 1000));
  const nowdeal = new Date();
  const timeDifferencedeal = saleEnddeal - nowdeal;
  
  if (timeDifferencedeal <= 0) {
    return 'Timer Expired';
  } else if (timeDifferencedeal > 0 && nowdeal >= saleStartdeal) {
    const hoursd = Math.floor(timeDifferencedeal / (1000 * 60 * 60));
    const minutesd = Math.floor((timeDifferencedeal % (1000 * 60 * 60)) / (1000 * 60));
    const secondsd = Math.floor((timeDifferencedeal % (1000 * 60)) / 1000);
    
    const formattedHoursd = String(hoursd).padStart(2, '0');
    const formattedMinutesd = String(minutesd).padStart(2, '0');
    const formattedSecondsd = String(secondsd).padStart(2, '0');
    
    return `${formattedHoursd}:${formattedMinutesd}:${formattedSecondsd}`;
  } else {
    return 'Timer Not Started';
  }
}

// Function to send timer value as cart attribute
async function sendTimerToCart(timerValue) {
  const attributeName = 'offerTimerAtCheckout';
  const formData = new FormData();
  formData.append(`attributes[${attributeName}]`, timerValue);

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error sending timer to cart:', error);
  }
}

// Function to handle checkout button click and send timer
function handleCheckoutTimerCapture() {
  const currentTimer = getCurrentTimerValue();
  sendTimerToCart(currentTimer).then(() => {
  });
}

// Make function globally available
window.handleCheckoutTimerCapture = handleCheckoutTimerCapture;

async function setCartOffertimer(time) {

  // if(elem.className === 'dummy-button-to-offer'){
  //   let buynowDisabled = Boolean(elem.nextElementSibling?.querySelector('button')?.getAttribute('disabled'));
   
  //   if(buynowDisabled) {
  //     elem.style.display = 'none';
  //     return;
  //   }
  //   else{elem.style.display=""}
  // }
  let offerTimerVal = 'No offer';
  if (time) {
    offerTimerVal = time;
  }
  const formData = new FormData();
  formData.append('attributes[offerTimer]', offerTimerVal);

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
  } catch (error) {
    console.error('Error:', error);
  }
  // elem.style.display="none";
  // elem.nextElementSibling?.querySelector('button')?.click();
}


